import { createContext, useContext, useMemo, useState } from "react";
import MainNavBar, { MainNavBarLogoType } from "../components/navbar/MainNavBar";

const NavBarContext = createContext();

export const NavBarProvider = ({ children }) => {
    const [ logoType, setLogoType ] = useState(MainNavBarLogoType.GENERAL);
    const contextValue = useMemo(() => ({ setLogoType }), []);

    return (
        <NavBarContext.Provider value={contextValue}>
            <header>
                <MainNavBar logoType={logoType}  />
            </header>
            {children}
        </NavBarContext.Provider>
      );
}

export const LogoType = MainNavBarLogoType;
export const useMainNavBarLogoType = () => useContext(NavBarContext);